export default __webpack_public_path__ + "static/media/restaurant-3-rMIN.72c6ad93.jpg";